import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateExpenseTypeApi } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import { fetchExpenseTypes } from "../../store/Slices/ExpenseTypeSlice";

const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId = "" } = userData;

const AddExpenseTypeModal = ({ Open, setOpen }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmed = name.trim();
    if (!trimmed) {
      WarningToast("Enter expense type name");
      setLoading(false);
      return;
    }

    try {
      const response = await CreateExpenseTypeApi({
        name: trimmed,
        branchId,
      });
      if (response.data.success) {
        setOpen(false);
        setName("");
        SuccessToast("Expense type added");
        dispatch(fetchExpenseTypes());
      } else {
        ErrorToast(response.data.error?.msg);
      }
    } catch (err) {
      console.error(err);
      ErrorToast(err.response?.data?.error?.msg || "Failed to add expense type");
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Expense Type
        </h1>
        <div className="px-10">
          <AuthInput
            label="Type name"
            placeholder="e.g. Transport"
            Value={name}
            setValue={setName}
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title="Add Type" onSubmit={onSubmit} type={1} />
              <AuthBtn title="Cancel" onSubmit={() => setOpen(false)} type={2} />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddExpenseTypeModal;
